import HelpIconTooltip from '@components/shared/HelpIconTooltip';
import Product from '@models/product';
import { warm } from '@style/variables';
import Value from './_Value';
import { classNames } from '@repo/ui/src/utils/classNames';

export interface Props {
  attribute?: string;
  shortDescription?: string;
  salesforceField?: string;
  products: Array<Product>;
  selectedSkus: Array<string>;
  asContentRow?: boolean;
}

const Attribute = ({
  attribute,
  shortDescription,
  salesforceField,
  products,
  selectedSkus,
  asContentRow,
}: Props) => {
  return (
    <div className="attribute-row tw-border-b-surface-200 tw-border-b last:tw-border-b-0 md:tw-grid md:tw-grid-cols-[minmax(0,1fr),minmax(0,3fr)] tw-items-center [&_svg]:!tw-m-t-0">
      <div className="tw-flex [&_span]:tw-self-center">
        <p className="tw-text-text-400 tra-text-web-body-l tw-font-bold tw-py-4 tw-sticky tw-left-0 tw-pl-6 ">
          {attribute}
        </p>
        {shortDescription && (
          <HelpIconTooltip
            text={shortDescription}
            altColor={warm[900]}
            closeLabel="close information dialog"
            label="tooltip"
            border
          />
        )}
      </div>
      <div
        className={classNames(
          'tw-py-4 tw-grid md:tw-grid-cols-3 tw-items-center tw-justify-center tw-gap-6 tw-pl-8 md:tw-pl-0 tw-w-full',
          asContentRow
            ? 'tw-grid-cols-[repeat(3,250px)]'
            : 'tw-grid-cols-[minmax(0,1fr),minmax(0,2fr)]',
        )}
      >
        {salesforceField &&
          selectedSkus.map((sku, i) => {
            const { customFields } =
              products.find(({ sku: productSku }: { sku: string }) => sku === productSku) || {};
            const salesforceValue = customFields?.[salesforceField];

            return (
              <div
                className="tw-grid tw-w-full tw-items-center tw-justify-center tw-text-center"
                key={i}
              >
                <Value salesforceValue={salesforceValue} />
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default Attribute;
